// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Manrope_1b340f', '__Manrope_Fallback_1b340f'","fontStyle":"normal"},"className":"__className_1b340f","variable":"__variable_1b340f"};